/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name warning-message
 * @description Displays a warning message to the user with information about a feature
 * @attr {string} message The message to display.
 * @attr {string} link The link to use for the 'learn more' link added to the end of the message.
 */
angular
  .module("mercury.directives.warningmessage", [])
  .directive("warningMessage", ["userinfo", function (userinfo) {
    return {
      restrict: "E",
      templateUrl:
        "directives/warningmessage/warningmessage.tpl.html",
      // bind the attributes to scope variables
      scope: {
        key: "@",
        message: "@",
        link: "@",
      },
      link: function (scope, element, attrs) {
        // We dismiss messages for whoever is logged in. This crosses
        // between venues they have access to.
        const key = `@@loaded/banner/dismissed/${userinfo.userDetails().id}/${
          attrs.key
        }`;
        scope.shouldShow = !window.localStorage.getItem(key);

        // handle the user dismissing the message, it shouldn't be shown again
        // unless they clear their browser storage
        scope.dismiss = function () {
          scope.shouldShow = false;
          window.localStorage.setItem(key, true);
        };

        scope.messageTitle = attrs.messageTitle;
      },
    };
  }]);
